import React, { Component, PropTypes } from 'react';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import { provideHooks } from 'redial';
import prioritise from 'bluebird-prioritise';

import Promise from 'bluebird';

import { getPaginationPrevNext } from '@seek/seek-jobs-seo';
import { persistCriteriaLocally, persistCriteriaRemotely, clearActiveRefinement } from 'store/search/search';
import { getResults, moreOptions, resultPageLoad } from 'store/results/results';
import { savedJobSearch } from 'store/savedJobs/savedJobs';
import { getSerpLmis } from 'store/lmis/lmis';
import SearchResultPage from 'SearchResultPage/SearchResultPage';
import { saveJob } from 'store/savedJobs/savedJobs';

const removeNulls = array => array.filter(x => x !== null);

const hooks = {
  fetch: ({ dispatch, state, locale, path, query, cookies }) => {
    const { paginationParameters = {} } = state;

    const searchArgs = {
      locale,
      path,
      query,
      paginationParameters,
      cookies
    };

    if (ENV.SERVER) {
      return prioritise(
        dispatch(getResults(searchArgs)),
        dispatch(getSerpLmis())
      );
    }

    return state.moreOptions ?
      dispatch(moreOptions()) :
      Promise.join(
        dispatch(getResults(searchArgs)),
        dispatch(getSerpLmis())
      );
  },
  defer: ({ dispatch, routeEnter, state }) => {
    if (routeEnter && window.hj) {
      window.hj('trigger', 'search-results-all-browsers');
    }

    return !state.moreOptions && dispatch(persistCriteriaLocally());
  },
  intents: ({ dispatch, handleIntent }) => {
    handleIntent('savejob', id => {
      const savedJob = document.getElementById(id);

      if (savedJob) {
        savedJob.scrollIntoView();
      }

      dispatch(saveJob(id, true));
    });
  },
  mashup: ({ dispatch, state, authenticated, locale }) => {
    return !state.moreOptions && authenticated && Promise.join(
      dispatch(persistCriteriaRemotely(locale)),
      dispatch(savedJobSearch())
    );
  },
  pageLoad: ({ dispatch, state }) => {
    return !state.moreOptions && dispatch(resultPageLoad());
  }
};

function mapStateToProps({ location, results, search }) {
  return {
    currentUrl: location.url,
    title: results.title,
    pagination: results.pagination,
    page: search.query.page
  };
}

function mapDispatchToProps(dispatch) {
  return {
    clearActiveRefinement: () => dispatch(clearActiveRefinement())
  };
}

@provideHooks(hooks)
@connect(mapStateToProps, mapDispatchToProps)
class SearchResults extends Component {

  static propTypes = {
    currentUrl: PropTypes.string.isRequired,
    title: PropTypes.string,
    pagination: PropTypes.object,
    page: PropTypes.string,
    clearActiveRefinement: PropTypes.func.isRequired
  };

  componentWillUnmount() {
    this.props.clearActiveRefinement();
  }

  render() {
    const { currentUrl, title, pagination, page } = this.props;

    const { next, prev } = pagination !== null ?
      getPaginationPrevNext({
        url: currentUrl,
        lastPageNumber: pagination.lastPage
      }) : {};

    const titlePageNumber = parseInt(page, 10) > 1 ? ` (Page ${page})` : '';

    const meta = {
      title: title.length > 0 ? `${title}${titlePageNumber} - SEEK` : 'SEEK',
      link: removeNulls([
        next ? { rel: 'next', href: next } : null,
        prev ? { rel: 'prev', href: prev } : null
      ])
    };

    return (
      <div>
        <Helmet {...meta} />
        <SearchResultPage />
      </div>
    );
  }

}

export default SearchResults;



/** WEBPACK FOOTER **
 ** ./app/handlers/SearchResults.js
 **/